import { render, staticRenderFns } from "./DataTableActions.vue?vue&type=template&id=08673a0e&scoped=true&"
import script from "./DataTableActions.vue?vue&type=script&lang=js&"
export * from "./DataTableActions.vue?vue&type=script&lang=js&"
import style0 from "./DataTableActions.vue?vue&type=style&index=0&id=08673a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08673a0e",
  null
  
)

export default component.exports